import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import FounderRoomForm from 'components/views/FounderRooms/_components/FounderRoomForm';
import { handleSubmitUpdateRoom } from 'components/views/FounderRooms/_helpers/founderRooms.events';
import { $form, $view } from 'signals/global.signals';

const FounderEditRoomModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'founder-room-edit'}
    title={`Edit Room - ${$form.value.name} - ${$form.value.dealName}`}
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitUpdateRoom}
    primaryButtonText="Save"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
    size="xl"
  >
    <FounderRoomForm mode="edit" />
  </SimpleModal>

);

export default FounderEditRoomModal;
